/**
 * DEV-банер impersonation (Sprint A1).
 *
 * Показується поверх усього, коли активна impersonation (є знімок адміна в
 * localStorage). Дає повернутись у себе одним кліком — навіть із кабінету
 * ролі, що не має доступу до Пульта супер-адміна.
 *
 * Рендериться завжди у корені App; сам вирішує, показуватись чи ні.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";
import { getAdminSnapshot, clearAdminSnapshot } from "@/lib/devImpersonate";

export function DevImpersonationBar() {
  const nav = useNavigate();
  const claims = useAuthStore((s) => s.claims);
  const [snap, setSnap] = useState(getAdminSnapshot());

  // Перечитувати знімок при зміні сесії (вхід/вихід impersonation).
  useEffect(() => {
    setSnap(getAdminSnapshot());
  }, [claims]);

  // Резервуємо місце під бар: клас на body зсуває контент і sticky-шапки нижче
  // (глобальні правила в index.css) — щоб бар не перекривав функціонал.
  useEffect(() => {
    document.body.classList.toggle("dev-impersonating", !!snap);
    return () => document.body.classList.remove("dev-impersonating");
  }, [snap]);

  if (!snap) return null;

  const whoNow =
    claims?.kind === "seamstress"
      ? `швея: ${claims?.name ?? ""}`
      : `${claims?.roles?.join(", ") || claims?.email || "?"}`;

  function back() {
    const s = getAdminSnapshot();
    if (s) {
      useAuthStore.getState().setSession(s.tokens, s.user);
    }
    clearAdminSnapshot();
    setSnap(null);
    // Пульт супер-адміна, вкладка «Увійти як…»: окремої сторінки
    // /dev/login-as більше немає.
    nav("/admin/panel");
  }

  return (
    <div className="fixed inset-x-0 top-0 z-[9999] h-7 flex items-center justify-center gap-2 bg-rose-600 px-3 text-xs font-medium text-white shadow whitespace-nowrap">
      <span className="min-w-0 truncate">🛠 DEV — ти зараз як <b>{whoNow}</b></span>
      <button
        onClick={back}
        className="flex-none rounded bg-white/20 px-2 py-0.5 font-semibold hover:bg-white/30"
      >
        ← Назад в адміна
      </button>
    </div>
  );
}
